import { createSlice } from "@reduxjs/toolkit";

export const temperingScheduleSlice = createSlice({
  name: "temperingSchedule",
  initialState: {
    isSchedulingMode: false,
  },
  reducers: {
    toggleTemperingScheduleMode: (state) => {
      state.isSchedulingMode = !state.isSchedulingMode;
    },
  },
});

export const { toggleTemperingScheduleMode } = temperingScheduleSlice.actions;

export default temperingScheduleSlice.reducer;
